module.exports = __webpack_public_path__ + "img/money-bag.b722fdde.png";